import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

// Rotation weeks are counted from one shared Monday, so week A is the same
// calendar week for everyone and a rotation can grow without renumbering.
const ROTATION_EPOCH = '2026-01-05'

/** 0-based rotation week of a calendar day (YYYY-MM-DD). */
export function rotationWeekIndex(dateKey: string, weeks: number): number {
  // UTC dates: a local diff across a DST change comes out an hour short and
  // truncates to the previous day.
  const days = dayjs.utc(dateKey).diff(dayjs.utc(ROTATION_EPOCH), 'day')
  const week = Math.floor(days / 7)
  return ((week % weeks) + weeks) % weeks
}

/** Week 0 is A, week 1 is B, … */
export function rotationWeekLabel(weekIndex: number): string {
  return String.fromCharCode(65 + weekIndex)
}
